import styled from '@emotion/styled';

export const PricesSummaryFiltersWrapper = styled.div`
  display: flex;
  align-items: center;
  ${({ theme }) => theme.media.showAt({ to: 1 }) `
    margin: ${theme.spacing(2)} 0 ${theme.spacing(1)};
  `}
  ${({ theme }) => theme.media.showAt({ from: 2 }) `
    margin: ${theme.spacing(1)} 0;
    > div:first-of-type {
      white-space: nowrap;
    }
    > *:not(label) {
      margin-${theme.isRTL ? 'left' : 'right'}: ${theme.spacing(1)};
    }
    > label {
      margin-${theme.isRTL ? 'right' : 'left'}: auto;
    }
  `}
`;

export const PricesSummaryFilterWrapper = styled.div`
  position: relative;
  > div {
    position: absolute;
    top: 0;
    ${({ theme }) => theme.isRTL ? 'right' : 'left'}: 0;
    z-index: 2;
  }
`;

export const ScrollableWrapper = styled.div`
  ${({ theme }) => `
    overflow: auto;
    margin: 0 -${theme.spacing(2)};
    scroll-behavior: smooth;
    display: flex;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox, Safari 18.2+, Chromium 121+ */
    &::-webkit-scrollbar {
      display: none; /* Older Safari and Chromium */
    }
    > div {
      flex-grow: 1;
      min-width: unset;
      margin: 0 ${theme.spacing(1.5)};
    }
  `}
`;

export const PricesMobileFilterWrapper = styled.article`
  ${({ theme }) => `
    padding: ${theme.spacing(3)};
    position: relative;

    > h3 {
      margin-bottom: ${theme.spacing(3)};
    }
    &:not(:last-of-type) {
      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 24px;
        right: 24px;
        height: 1px;
        background: ${theme.colors.neutrals.grey9};
      }
    }
  `}
`;
